import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

//  Styles
import './Footer.scss';

//  Images
import logo from '../images/logo-v2-inverse.png';

const Footer = () => {
	return (
		<footer className="bg-danger w-100">
			<Container className="py-2 text-center">
				<img src={logo} className="img-fluid" alt="FSDev" />
				<hr className="text-white" />
				<Row className="pt-4">
					<Col
						xs={12}
						md={6}
						className="text-center text-md-start mb-2 px-3">
						<h2 className="text-white text-uppercase mb-3">
							FS Dev
						</h2>
						<blockquote className="blockquote mb-0">
							<p className="text-white fw-light text-center text-sm-start fst-italic">
								"I am not a genius, I am just curious."
							</p>
							<div className="blockquote-footer text-white ">
								Albert Einstein
							</div>
						</blockquote>
					</Col>
					<Col
						xs={12}
						md={3}
						className="text-center text-md-start mb-2">
						<h2 className="text-white text-uppercase mb-3">
							Pages
						</h2>
						<p className="text-center text-md-start text-white ps-1">
							<Link to="/">Home</Link>
						</p>
						<p className="text-center text-md-start text-white ps-1">
							<Link to="/contact">Contact me</Link>
						</p>

						<p className="text-center text-md-start text-white ps-1">
							<Link to="/policies/privacy">
								Privacy Policy
							</Link>
						</p>
						<p className="text-center text-md-start text-white ps-1">
							<Link to="/policies/cookies">
								Cookies Policy
							</Link>
						</p>
					</Col>
					<Col
						xs={12}
						md={3}
						className="text-center text-md-start mb-2">
						<h2 className="text-white text-uppercase mb-3">
							Links
						</h2>
						<div className="social-icons  mb-3">
							<p className="text-center text-md-start">
								<a
									href="https://www.linkedin.com/in/francisco-ribeiro-e-silva-144b511a9/"
									target="_blank"
									rel="noopener noreferrer">
									<i className="fab fa-linkedin"></i> LinkedIn
								</a>
							</p>
							<p className="text-center text-md-start">
								<a
									href="https://github.com/KikoRSilva/"
									target="_blank"
									rel="noopener noreferrer">
									<i className="fab fa-github"></i> Github
								</a>
							</p>
							<p className="text-center text-md-start">
								<a
									href="https://www.facebook.com/profile.php?id=100001516611711"
									target="_blank"
									rel="noopener noreferrer">
									<i className="fab fa-facebook-f"></i>{' '}
									Facebook
								</a>
							</p>
							<p className="text-center text-md-start">
								<a
									href="https://www.instagram.com/franciscomrsilva/?hl=pt"
									target="_blank"
									rel="noopener noreferrer">
									<i className="fab fa-instagram"></i>{' '}
									Instagram
								</a>
							</p>
							<p className="text-center text-md-start">
								<a
									href="https://www.youtube.com/channel/UCRcOsqmu6Mtgf0YOialHcwA"
									target="_blank"
									rel="noopener noreferrer">
									<i className="fab fa-youtube"></i> Youtube
								</a>
							</p>
						</div>
					</Col>
				</Row>
				<hr className="text-white" />
				<div className="copyrights mt-1 mb-0 pb-0">
					<p className="text-center text-white">
						&copy; 2022 - Francisco Ribeiro e Silva | All rights reserved
					</p>
				</div>
			</Container>
		</footer>
	);
};

export default Footer;
